export const BASE_URL = "https://cart-gear-22.onrender.com";
// export const BASE_URL = "https://cart-gear-22.onrender.com";
// export const BASE_URL = "http://localhost:5000";
